export const CURR_API = 'https://mychart.pacmny.com/keyon';
export const OTHER_API = 'http://20.84.40.214/keyon';
